<template>
  <div class="bound-select-people">
    <el-dialog title="自定义候选人" class="bound-select-people-dialog" :visible.sync="selectPersonDialog.dialogVisible" :before-close="cancel" center @open="open()" :close-on-click-modal="false" append-to-body>
      <div class="selected">
        <select-person v-if="selectPersonDialog.selectType==='user'&& selectPersonDialog.dialogVisible" :remoteSearch="true" :treeData="selectPersonDialog.allPerson" :select="select" ref="select" :isRadio="'radio'" :type="'group'"></select-person>
        <select-node v-if="selectPersonDialog.selectType==='component'" :treeData="selectPersonDialog.allPerson" :select="select" ref="select" :single="true"></select-node>
      </div>
      <div class="buttons">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectPerson from '../../system/select-person'
import SelectNode from '../../system/select-node'

export default {
  name: 'BoundSelectPeople',
  props: ['selectPersonDialog'],
  components: {
    SelectPerson,
    SelectNode
  },
  data () {
    return {
      select: []
    }
  },
  methods: {
    open () {
      this.select = this.selectPersonDialog.boundPeoples || []
    },
    save () {
      let select = []
      this.$refs.select.getSelectedList().forEach(m => {
        select.push({
          'id': m.columnId || m.id,
          'name': m.name,
          'type': m.type
        })
      })
      this.$emit('saveBoundSelectPerson', select)
      this.selectPersonDialog.dialogVisible = false
    },
    cancel () {
      this.selectPersonDialog.dialogVisible = false
    }
  }
}
</script>

<style lang="scss">
  .bound-select-people-dialog {
    .el-dialog {
      height: 430px;
      width: 646px;
      div.el-dialog__header {
        height: 34px;
      }
      div.el-dialog__body {
        height: 100%;
        width: 100%;
        padding: 0 0 0 0;
        .selected {
          margin-top: 19px;
        }
        form.el-form {
          margin-top: 30px;
          padding-left: 61px;
          .el-form-item {
            margin-right: 17px;
            .el-form-item__label {
              font-size: 14px;
            }
            .explain {
              font-size: 12px;
              color: #B3B3B3;
            }
            .el-form-item__content {
              .el-input {
                width: 162px;
              }
              height: 28px;
              .el-select {
                width: 100%;
                height: 100%;
              }
            }
          }
          > div {
            margin-top: 0px;
            padding-left: 0px;
          }
        }
        .buttons {
          text-align: center;
          margin-top: 25px;
          button {
            width: 104px;
            height: 30px;
            span {
              font-size: 16px;
            }
            &:first-child {
              margin-right: 35px;
            }
          }

        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/process/design/bound-select-people.vue